import { gql } from '@apollo/client';
import { UTILITY_FRAGMENT } from '~/services/fetch-utility/fetch-utility.queries';

export const FUNNEL_PACKET_FRAGMENT = gql`
  fragment FunnelPacketData on FunnelPacket {
    onboardingRateClasses {
      id
      displayName
    }
    customPlan {
      id
      paymentMethodId
      planTemplate {
        id
        billingExperienceType
      }
      billingAddress {
        id
        streetOne
        streetTwo
        city
        state
        zipCode
        addressType
      }
      utilityAccounts {
        id
        serviceAddressZip
        serviceAddressState
        serviceAddressCity
        serviceAddressStreetOne
        serviceAddressStreetTwo
      }
    }
    funnelConfiguration {
      showLmiScreens
      signUpContractTemplate {
        id
        savingsPercentage
      }
    }
    signedContractIds
    funnelVnmProjectId
    signupContractTemplate {
      id
      savingsPercentage
      supportedCustomerTypes
      proofDocRequirement
      paymentProvider
    }
    nonLmi
    inviteCode
    funnelEnrollmentExperience
    meter {
      id
      meterNumber
    }
    utilityAccount {
      id
      communitySolarProjectGroup {
        id
        usesIpaContracts
      }
      annualizedUsageEstimate
      accountNumber
      secondaryAccountIdentifier
      serviceAddressZip
      serviceAddressState
      serviceAddressCity
      serviceAddressStreetOne
      enrollmentDataSourceName
      serviceAddressStreetTwo
      account {
        id
        businessName
        customerType
      }
      user {
        id
        firstName
        lastName
        email
        metaData
        originationSource {
          originationSourceType
          funnel
          enrollmentExperience
          queryParams
        }
        phoneNumber: phone
        zipCode: zip
        signupPromoCode {
          code
        }
        signupFunnelLead {
          paymentService
        }
        phone
      }
      utility {
        ...UtilityData
      }
      utilityCredential {
        id
        username
        verificationStatus
      }
      utilityAccountMissingError
    }
    unparsedQueryParams {
      utilityAccountNumber
      secondaryAccountId
      meterNumber
      annualizedUsageEstimate
    }
    projectSnapshot {
      ira
      product
      salesforceUtilityId
      programName
      lmiProductId
      collectPayment
      productId
      savingsPercent
      ciCapacityAvailable
      lmiCapacityAvailable
      resiCapacityAvailable
      smallCsCapacityAvailable
      waitlist
    }
  }
  ${UTILITY_FRAGMENT}
`;

export const FETCH_FUNNEL_PACKET = gql`
  query Flex_FetchFunnelPacket(
    $accountId: Int
    $customPlanId: Int
    $userId: Int!
    $utilityAccountId: Int
  ) {
    funnelPacket(
      accountId: $accountId
      customPlanId: $customPlanId
      userId: $userId
      utilityAccountId: $utilityAccountId
    ) {
      ...FunnelPacketData
    }
  }
  ${FUNNEL_PACKET_FRAGMENT}
`;
